import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";

const features = [
  {
    title: "For Guests",
    features: [
      "All tickets you purchase are saved here.",
      "Download tickets anytime — as long as you’ve paid for it.",
    ],
  },
  {
    title: "For Organizers",
    features: [
      "Create as many events as you want.",
      "Get paid quickly - We make ticket payouts the next day.",
    ],
  },
];

export const WelcomeModal = ({ open, handleClose }: ModalCompProps) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="!p-0"
      dialogClassName="!my-0"
      showHeader={false}
    >
      <div className="bg-blue-bg relative flex justify-center pt-[42px]">
        <img
          src="/assets/images/tikket-phone.png"
          alt="welcome"
          className="h-auto w-full max-w-[300px]"
        />

        <button
          type="button"
          className="absolute right-3.5 top-3.5 rounded-full bg-white p-2 text-grey-950"
          onClick={handleClose}
        >
          <Icon svg="close-icon" width={20} height={20} className="" />
        </button>
      </div>

      <div className="flex flex-col gap-4 p-5">
        <p className="font-fraunces text-2xl tracking-[-4%]">
          Welcome to Tikket ⚡
        </p>

        {features.map((feat, idx) => {
          const key = `feature-${feat.title}-${idx}`;
          return (
            <div className="flex flex-col gap-2" key={key}>
              <p className="font-bold text-grey-900">{feat.title}</p>
              <div className="flex flex-col gap-1.5">
                {feat.features.map((item, idx) => {
                  return (
                    <div
                      key={`${key}-${idx}`}
                      className="flex gap-1.5 font-medium text-grey-900 md:items-center"
                    >
                      <Icon
                        svg="circle-check"
                        width={16}
                        height={16}
                        className="min-w-max text-grey-400"
                      />
                      <p>{item}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

        <Button
          type="button"
          text="Continue"
          onClick={handleClose}
          className="mt-2"
        />
      </div>
    </ModalComponent>
  );
};
